<header id="site-header" dir="rtl">
  <div class="header-inner">
    <a class="logo-wrapper" routerLink="/">
      <img src="./assets/imgs/company.png" alt="" width="44" height="44">
      <span>شرکت دانش‌بنیان رایان اندیشه نصر</span>
    </a>

    <div class="dropdown-container">
      <button class="menu-button" id="dropdownMenuButton" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label="باز کردن منو">
        <mat-icon aria-hidden="true">menu</mat-icon>
        <span>منو</span>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li *ngIf="specialistUser"><a class="dropdown-item" [routerLink]="['/specialist-verification']"><mat-icon aria-hidden="true">account_circle</mat-icon>{{specialistUser.strFullName}}</a></li>
        <li *ngIf="specialistUser"><a class="dropdown-item" [routerLink]="['/specialist-change-password']"><mat-icon aria-hidden="true">lock_outline</mat-icon>تغییر رمز عبور</a></li>
        <li *ngIf="!specialistUser"><a class="dropdown-item" [routerLink]="['/specialist-login']"><mat-icon aria-hidden="true">login</mat-icon>ورود کارشناس</a></li>
        <li *ngIf="specialistUser"><a class="dropdown-item" [routerLink]="['/specialist-my-registration']"><mat-icon aria-hidden="true">assignment</mat-icon>ثبت‌نامی‌های من</a></li>
        <li><a class="dropdown-item" [routerLink]="['/general']"><mat-icon aria-hidden="true">gavel</mat-icon>قوانین و مقررات</a></li>
        <li><a class="dropdown-item" [routerLink]="['/about']"><mat-icon aria-hidden="true">info_outline</mat-icon>درباره ما</a></li>
        <li *ngIf="isLogin || specialistUser"><button type="button" class="dropdown-item" (click)="logOut()"><mat-icon aria-hidden="true">logout</mat-icon>خروج</button></li>
      </ul>
    </div>
  </div>
</header>

<router-outlet></router-outlet>
